import { lazy, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Element } from 'react-scroll';
import { customScrollTo } from '../../components/customScrollTo';
const Hero = lazy(() => import('./Hero'));
const AboutMe = lazy(() => import('./AboutMe'));
const PortfolioImageGrid = lazy(() => import('./PortfolioShowcaseSection/PortfolioImageGrid'));

export interface IHistoryState {
	scrollTo: string;
	offset?: number;
}

function HomePage() {
	let history = useHistory();

	useEffect(() => {
		if (history.location.state !== undefined) {
			const { scrollTo, offset }: IHistoryState = history.location.state as IHistoryState;
			setTimeout(() => {
				customScrollTo(scrollTo, offset);
			}, 100);
		}
	}, [history]);

	return (
		<div className='App' style={{}}>
			<Element name='hero'>
				<Hero />
			</Element>
			<Element name='aboutMe'>
				<AboutMe />
			</Element>
			<Element name='main_page_grid'>
				<PortfolioImageGrid />
			</Element>
		</div>
	);
}

export default HomePage;
